import { generateClasses } from '../../utilities/components/styles';
import { mediaBreakpointDown, mediaBreakpointUp, sizes } from "conversional-theme";
export var Styles = function () {
    var _a, _b;
    return {
        multiStepQuestionContainer: { display: "flex", width: "100%" },
        currentStepQuestion: (_a = {},
            _a[mediaBreakpointDown(sizes.xs)] = {
                width: "100% !important"
            },
            _a[mediaBreakpointUp(sizes.sm)] = {
                maxWidth: "400px !important",
                marginTop: 12
            },
            _a),
        previousOptionsContainer: (_b = {},
            _b[mediaBreakpointDown(sizes.xs)] = {
                display: "none"
            },
            _b),
    };
};
export var renderClasses = generateClasses(Styles);
